import IPCRoutes from './IPCRoutes';

export default IPCRoutes;
